import { createFileRoute, Outlet, useLocation, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useStore } from '@/store'
import { useShallow } from 'zustand/shallow'
import Login from '@/components/features/login'
import { Menu } from 'lucide-react'
import { ProfileMenu } from '@/components/features/profile-menu'
import { useSidebar } from "@/components/ui/sidebar"
import { useQuery } from '@tanstack/react-query'
import { Api, getLspReportBppId } from '@/lib/utils'

export const Route = createFileRoute('/_auth')({
    component: RouteComponent,
})

function RouteComponent() {
    const location = useLocation()
    const navigate = useNavigate()

    const { loggedIn, token, accountId } = useStore(useShallow(state => ({
        loggedIn: state.loggedIn,
        token: state.token,
        accountId: state.selectedAccount.id
    })))
    const lspReportBppId = getLspReportBppId(accountId)

    const { setOpenMobile } = useSidebar()

    const getWalletBalance = useQuery({
        queryKey: ['billing_info', token],
        queryFn: () => Api<{ status: number, enforce_credit_limit: boolean, wallet_balance: number | undefined, wallet_status: number | undefined }>('/webui/wallet_balance', "POST", {}, { token }),
        staleTime: 5 * 60 * 1000,
        refetchInterval: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        enabled: loggedIn
    })

    useEffect(() => {
        if (loggedIn && lspReportBppId && location.pathname === '/orders') {
            navigate({ to: '/reports/lsp', replace: true })
        }
    }, [loggedIn, lspReportBppId, location.pathname, navigate])

    if (loggedIn) {
        return <div className='w-full'>
            {!location.pathname.includes('paytm') ? <div className='w-full h-14 border-b border-gray-100 lg:px-10 px-2 flex items-center justify-between'>
                <Menu className='w-6 h-6' onClick={() => setOpenMobile(true)} />
                <div className='flex items-center gap-3'>
                    <div>
                        <p>{accountId}</p>
                        {getWalletBalance.data && getWalletBalance.data.wallet_balance !== undefined && getWalletBalance.data.wallet_status !== undefined && getWalletBalance.data.enforce_credit_limit ?
                            <p className={`font-semibold text-sm text-right
                    ${getWalletBalance.data.wallet_status === 0 ? 'text-red-500' : getWalletBalance.data.wallet_status === 1 ? 'text-orange-400' : ''}`}>{`₹${parseInt((getWalletBalance.data.wallet_balance || 0).toString()).toLocaleString('en-IN')}`}</p> : null}
                    </div>
                    <ProfileMenu />
                </div>
            </div> : null}
            <Outlet />
        </div>
    } else {
        return <Login />
    }
}
